export default __webpack_public_path__ + "static/media/html.f023bfe2.png";